import { useFixedContainedBgImage } from "./global/hooks"

export default function MainPageBanner() {
    const bannerElemRef = useFixedContainedBgImage(828, 1172, 86, -12)
    return (
        <div ref={bannerElemRef} id="MainPageBanner"></div>
    )
}